<template>
  <div class="pregled-vsebine">
    <div class="postavitev-izbirnika">
      <div class="izbirnik-stranke">
        <div>
          <IzbirnikStranke v-on:osvezitevIzbranSap="GetSap" />
        </div>
      </div>
      <div style="clear: both"/>
    </div>
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine ">
        <div>
          <p class="open-sans-30pt">
            Nastavitve telefonije
          </p>
        </div>
        <div style="padding-top: 20px; padding-bottom: 15px">
          <div style="padding-top: 5px">
            <div>
              <span class="izbirnik-odmik-zgoraj">
                Izberite številko
              </span>
              <el-select
                value-key="telefonska_stevilka"
                v-model="izbranaTelefonska"
                placeholder="Izberite tel. številko"
                class="postavitev-izbirnika-stevilke"
                :disabled="pogrupiraneTelStevilke.length === 0"
                filterable>
                <el-option-group
                  v-for="grupa in pogrupiraneTelStevilke"
                  :key="grupa.label"
                  :label="grupa.label">
                  <el-option
                    v-for="(data, key) in grupa.seznamTelStevilk"
                    :value="data"
                    :key="key"
                    :label="VrniFormatiranoTelefonsko(data.telefonska_stevilka, data.tip_stevilke)">
                  </el-option>
                </el-option-group>
              </el-select>
          </div>
        </div>
      </div>
      <div style="clear: both"/>
        <div>
          <div class="obvestilo-prazen-seznam" v-if="this.izbranaTelefonska === null && pridobivanjeStevilk">
            <p>
              Na izbranem priključku ni možno upravljati nastavitev telefonije.
            </p>
          </div>
          <div v-if="this.izbranaTelefonska !== null && pridobivanjeStevilk">
            <div v-if="jeStacionarnaTelefonija  === true" style="clear: both; padding-top: 15px">
              <el-tabs type="border-card" class="tabs-cont">
                <el-tab-pane label="Preusmeritve">
                  <PreusmeritevStacionarnaTelefonija
                    :izbranPrikljucek="izbranaTelefonska.id_prikljucek"
                    :izbranaTelefonska="izbranaTelefonska.telefonska_stevilka"
                    :jeStatusOdzivnika="jeStatusOdzivnika"/>
                </el-tab-pane>
                <el-tab-pane label="Telefonski odzivnik">
                  <TelefonskiOdzivnik
                    :izbranPrikljucek="izbranaTelefonska.id_prikljucek"
                    :izbranaTelefonska="izbranaTelefonska.telefonska_stevilka"
                    v-on:jeStatusOdzivnika="PridobljenStatusOdzivnika"/>
                </el-tab-pane>
                <el-tab-pane label="Blokade klicev">
                  <BlokadeKlicov
                    :izbranPrikljucek="izbranaTelefonska.id_prikljucek"
                    :izbranaTelefonska="izbranaTelefonska.telefonska_stevilka"/>
                </el-tab-pane>
                <el-tab-pane label="Objava številke">
                  <ObjavaStevilke  :izbranPrikljucek="izbranaTelefonska.id_prikljucek"
                                   :izbranaTelefonska="izbranaTelefonska.telefonska_stevilka"/>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div v-else style="padding-top: 15px">
              <el-tabs type="border-card" class="tabs-cont">
                <el-tab-pane label="Nastavitve SIM">
                  <PodatkiSim
                    v-if="podatkiOsim !== null"
                    :izbranPrikljucek="izbranaTelefonska.id_prikljucek"
                    :izbranaTelefonska="izbranaTelefonska.telefonska_stevilka"
                    :prenosniPodatkiMoznostSMSDeblokade="prenosniPodatkiMoznostSMSDeblokade"
                    v-on:spremebaSmSDeblokade="NastaviMoznostDeblokadeSMS"
                    :prenosniPodatkiUmtsObvescanje="prenosniPodatkiUmtsObvescanje"
                    :privzetaVrednost="privzetaVrednost"
                    v-on:spremembaObvescanjeTujina="SprememebaInformativnoObvescanjeTujina"
                    :podatkiOsim="podatkiOsim"/>
                </el-tab-pane>
                <el-tab-pane label="Blokade">
                  <Blokade
                    :voiceFeaturesEnabled="voiceFeaturesEnabled"
                    :izbranPrikljucek="izbranaTelefonska.id_prikljucek"
                    :izbranaTelefonska="izbranaTelefonska.telefonska_stevilka"
                    :zaporeKlicevIzpis="zaporeKlicevIzpis"
                    :jeMobilniTopPaket="jeMobilniTopPaket"
                    :mednarodnoPodatkovneBlokade="mednarodnoPodatkovneBlokade"
                    :jePridobivanjePodatkovneBlokade="jePridobivanjePodatkovneBlokade"
                    :izbranaMednarodnoPodatkovneBlokade="izbranaMednarodnoPodatkovneBlokade"
                    :izbranaNacionalnaPodatkovnaBlokada="izbranaNacionalnaPodatkovnaBlokada"
                    :nacionalnePodatkovneBlokade="nacionalnePodatkovneBlokade"
                    :jePridobivanjeZaporeKlicev="jePridobivanjeZaporeKlicev"
                    :prenosniPodatkiKomercialnaSporocila="prenosniPodatkiKomercialnaSporocila"
                    :seznamRoamingProfilov="seznamRoamingProfilov"
                    v-on:spremembeRoamingProfili="SaveRoamingProfile"
                    v-on:ponovnoNaloziRoamingProfile="GetRoamingProfile"
                    v-on:spremebaStatusZaporeKlicev="NastaviZaporeKlicev"
                    v-on:spremebaMednarodnoPodatkovneBlokade="GetNastaviMednarodnoPodatkovnoBlokado"
                    v-on:nastaviBlokado="BlokadaKomercialnihSporocil"
                    v-on:odstraniBlokado="DeblokadaKomercialnihSporocil"
                    v-on:spremebaNacionalnePodatkovneBlokade="GetNastaviNacionalnoPodatkovnoBlokade"/>
                </el-tab-pane>
                <el-tab-pane label="Nastavitev APN točke">
                  <NastavitevApnTock :izbranPrikljucek="izbranaTelefonska.id_prikljucek"
                                     :izbranaTelefonska="izbranaTelefonska.telefonska_stevilka"/>
                </el-tab-pane>
                <el-tab-pane label="Preusmeritve" v-if="voiceFeaturesEnabled">
                  <PreusmeritevMobilnaTelefonija
                    v-if="podatkiOsim !== null"
                    :podatki-o-sim="podatkiOsim"
                    :izbranPrikljucek="izbranaTelefonska.id_prikljucek"
                    :izbranaTelefonska="izbranaTelefonska.telefonska_stevilka" />
                </el-tab-pane>
                <el-tab-pane label="Seznam roaming držav">
                  <SeznamRoamingDrzav />
                </el-tab-pane>
                <el-tab-pane label="Objava številke" v-if="voiceFeaturesEnabled">
                  <ObjavaStevilke  :izbranPrikljucek="izbranaTelefonska.id_prikljucek"
                                   :izbranaTelefonska="izbranaTelefonska.telefonska_stevilka" />
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NastavitevApnTock from './NastavitveTelefonije/NastavitveMobilnaTelefonija/NastavitevApnTock'
import PreusmeritevMobilnaTelefonija
  from './NastavitveTelefonije/NastavitveMobilnaTelefonija/PreusmeritevMobilnaTelefonija'
import Blokade from './NastavitveTelefonije/NastavitveMobilnaTelefonija/Blokade'
import PodatkiSim from './NastavitveTelefonije/NastavitveMobilnaTelefonija/PodatkiSim'
import TelefonskiOdzivnik from './NastavitveTelefonije/NastavitveStacionarnaTelefonija/TelefonskiOdzivnik.vue'
import PreusmeritevStacionarnaTelefonija
  from './NastavitveTelefonije/NastavitveStacionarnaTelefonija/PreusmeritevStacionarnaTelefonija'
import BlokadeKlicov from './NastavitveTelefonije/NastavitveStacionarnaTelefonija/BlokadeKlicov'
import SeznamRoamingDrzav from './NastavitveTelefonije/NastavitveMobilnaTelefonija/SeznamRoamingDrzav'
import IzbirnikStranke from '../GlobalneKomponente/IzbirnikStranke.vue'
import {Tabs, TabPane, Checkbox, Button, Select, Option, Input, MessageBox, OptionGroup} from 'element-ui'
import ClientAgent from '../../../../assets/js/clientAgent.js'
import ObjavaStevilke from './NastavitveTelefonije/ObjavaStevilke'
import {FormatirajTelefonskoStevilko}
  from '../../../../assets/js/globalne_funkcije/GlobalnoTelefonija/FormatTelefonskeStevilke.js'
import {PrikljucekStatusEnum} from '../../../../assets/js/Enum/PrikljucekStatusEnum'
import {TipStevilkeEnum} from '../../../../assets/js/Enum/TipStevilkeEnum'

export default {
  Name: 'NastavitveTelefonija',
  mixins: [FormatirajTelefonskoStevilko],
  data () {
    return {
      jeStacionarnaTelefonija: false,
      jeMobilniTopPaket: false,
      activetab: 't1',
      seznamTelStevilk: [],
      izbranaTelefonska: null,
      zaporeKlicevIzpis: [],
      prenosniPodatkiMoznostSMSDeblokade: [],
      mednarodnoPodatkovneBlokade: [],
      jePridobivanjePodatkovneBlokade: false,
      izbranaMednarodnoPodatkovneBlokade: {},
      izbranaNacionalnaPodatkovnaBlokada: {},
      nacionalnePodatkovneBlokade: [],
      podatkiOsim: null,
      prenosniPodatkiUmtsObvescanje: [],
      jePridobivanjeZaporeKlicev: false,
      privzetaVrednost: '',
      jeStatusOdzivnika: '',
      prenosniPodatkiKomercialnaSporocila: {},
      seznamRoamingProfilov: [],
      pridobivanjePodatkov: true,
      pridobivanjeStevilk: false,
      veljavniStatusZaPrikaz: [],
      pogrupiraneTelStevilke: [],
      seznamPrikljuckov: [],
      voiceFeaturesEnabled: true,
      izbranSap: '',
      stacinarniTipiStevilk: [TipStevilkeEnum.NI_DOLOCENO, TipStevilkeEnum.TELEFON, TipStevilkeEnum.ALARM]
    }
  },
  components: {
    ObjavaStevilke,
    SeznamRoamingDrzav,
    PodatkiSim,
    'NastavitevApnTock': NastavitevApnTock,
    'Blokade': Blokade,
    'PreusmeritevMobilnaTelefonija': PreusmeritevMobilnaTelefonija,
    'PreusmeritevStacionarnaTelefonija': PreusmeritevStacionarnaTelefonija,
    'BlokadeKlicov': BlokadeKlicov,
    'TelefonskiOdzivnik': TelefonskiOdzivnik,
    'IzbirnikStranke': IzbirnikStranke,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Select.name]: Select,
    [Option.name]: Option,
    [OptionGroup.name]: OptionGroup,
    [TabPane.name]: TabPane,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input
  },
  mounted () {
    this.veljavniStatusZaPrikaz = [
      PrikljucekStatusEnum.VKLOPLJEN
    ]
    this.clientAgent = new ClientAgent()
  },
  watch: {
    izbranaTelefonska () {
      if (this.izbranaTelefonska !== null) {
        this.podatkiOsim = null
        this.StacionarnaAliMobilnaTelSt()
      }
    }
  },
  methods: {
    HandleTabClick (tab) {
      this.activetab = tab.name
    },
    async GetSap (izbranSap) {
      if (izbranSap !== '') {
        this.izbranSap = izbranSap
        this.podatkiOsim = null
        await this.GetPrikljuckiDovoljenja(izbranSap)
        this.GetStevilke(izbranSap)
      }
    },
    async GetPrikljuckiDovoljenja (sap) {
      try {
        let resp = await this.clientAgent.makeRequest(
          'permissions/all',
          {permissions: ['PRIKLJUCKI']}
        )
        await this.SetPrikljuckiDovoljenja(resp)
      } catch (e) {
        this.ErrPrikljuckiDovoljenja(e)
      }
    },
    SetPrikljuckiDovoljenja (podatki) {
      this.seznamPrikljuckov = podatki.results.PRIKLJUCKI.additionalData
    },
    ErrPrikljuckiDovoljenja (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    GetStevilke (sap) {
      let param = ['permissionId=NASTAVITVE_TELEFONIJA']
      param.push('filter[sap]=' + sap)
      this.clientAgent.postWsRequest(
        this,
        'permissions/havePermission',
        param,
        null,
        'SetStevilkePrikljucka',
        'ErrStevilkePrikljucka')
    },
    SetStevilkePrikljucka (podatki) {
      this.pogrupiraneTelStevilke = []
      this.izbranaTelefonska = null
      this.seznamTelStevilk = podatki.permission.additionalData
      this.seznamTelStevilk.forEach(stevilka => {
        if (!this.seznamPrikljuckov.find(
          x => x.id_stranka_sap === this.izbranSap) &&
          stevilka.selector_id === this.izbranSap) {
          let najdenaSkupina = this.pogrupiraneTelStevilke.find(x => x.label === 'Priključki s pravico')
          if (!najdenaSkupina) {
            this.pogrupiraneTelStevilke.push({'seznamTelStevilk': [stevilka], 'label': 'Priključki s pravico'})
          } else if (!najdenaSkupina.seznamTelStevilk.includes(stevilka)) {
            najdenaSkupina.seznamTelStevilk.push(stevilka)
          }
        } else {
          this.seznamPrikljuckov.forEach(prikljucek => {
            if (stevilka.id_prikljucek === prikljucek.id_prikljucek && stevilka.selector_id === this.izbranSap) {
              if (stevilka.tip_stevilke === TipStevilkeEnum.UMTS && this.izbranaTelefonska === null) {
                this.izbranaTelefonska = stevilka
              }
              let groupa = stevilka.stacionarna_stevilka === '1' ? prikljucek.naslov : 'Mobilni priključki'
              let najdenaSkupina = this.pogrupiraneTelStevilke.find(x => x.label === groupa)
              if (najdenaSkupina === undefined) {
                this.pogrupiraneTelStevilke.push({'seznamTelStevilk': [stevilka], 'label': groupa})
              } else if (!najdenaSkupina.seznamTelStevilk.includes(stevilka)) {
                najdenaSkupina.seznamTelStevilk.push(stevilka)
              }
            }
          })
        }
      })
      if (this.pogrupiraneTelStevilke.length > 0 && this.izbranaTelefonska === null) {
        this.izbranaTelefonska = this.pogrupiraneTelStevilke[0].seznamTelStevilk[0]
      }
      this.pogrupiraneTelStevilke.sort(function (a, b) {
        if (a.label === 'Mobilni priključki') {
          return -1
        } else if (b.label === 'Mobilni priključki') {
          return 1
        } else return a.label < b.label ? -1 : a.label > b.label ? 1 : 0
      })
      this.pridobivanjeStevilk = true
    },
    ErrStevilkePrikljucka (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
      this.pridobivanjeStevilk = true
    },
    StacionarnaAliMobilnaTelSt () {
      this.voiceFeaturesEnabled = true
      for (let i = 0; i < this.seznamTelStevilk.length; i++) {
        if (this.seznamTelStevilk[i].telefonska_stevilka === this.izbranaTelefonska.telefonska_stevilka) {
          if (this.seznamTelStevilk[i].voice_features_enabled === '1') {
            this.voiceFeaturesEnabled = true
          } else if (this.seznamTelStevilk[i].voice_features_enabled === '0') {
            this.voiceFeaturesEnabled = false
          }
          this.jeMobilniTopPaket = this.seznamTelStevilk[i].mobilni_top_paket === '1'
          if (this.stacinarniTipiStevilk.includes(this.seznamTelStevilk[i].tip_stevilke) &&
              this.seznamTelStevilk[i].stacionarna_stevilka === '1') {
            this.jeStacionarnaTelefonija = true
          } else if ([TipStevilkeEnum.UMTS, TipStevilkeEnum.ALARM].includes(this.seznamTelStevilk[i].tip_stevilke)) {
            this.jeStacionarnaTelefonija = false
            this.GetMednarodnoPodatkovnoBlokado()
            this.GetMoznostSMSDeblokade()
            this.GetNaborCasovnihIzbir()
            this.GetNacionalnoPodatkovnoBlokado()
            this.GetZaporeKlicev()
            this.PridobiPodatkeSim()
            this.GetUmtsGostovanjeObvescanje()
            this.GetKomercialnaSporocila()
            this.GetRoamingProfile()
          }
        }
      }
    },
    PridobljenStatusOdzivnika (status) {
      this.jeStatusOdzivnika = ''
      this.jeStatusOdzivnika = status
    },
    GetUmtsGostovanjeObvescanje () {
      if (this.izbranaTelefonska !== null) {
        let param = ['idPrikljucek=' + this.izbranaTelefonska.id_prikljucek]
        param.push('stevilka=' + this.izbranaTelefonska.telefonska_stevilka)
        this.clientAgent.postWsRequest(this,
          'prikljucek/telefonija/umts/pridobiUmtsGostovanjeObvescanje?',
          param,
          null,
          'SetUmtsGostovanjeObvescanje',
          'ErrUmtsGostovanjeObvescanje')
      }
    },
    SetUmtsGostovanjeObvescanje (podatki) {
      this.prenosniPodatkiUmtsObvescanje = podatki.data
      this.privzetaVrednost = ''
      let infoData = podatki.data.info
      for (let i = 0; i < infoData.length; i++) {
        if (infoData[i].vkljuceno === true) {
          this.privzetaVrednost = infoData[i]
        }
      }
    },
    ErrUmtsGostovanjeObvescanje (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    SprememebaInformativnoObvescanjeTujina (idUmtsGostovanjeObvescanje) {
      this.prenosniPodatkiUmtsObvescanje = null
      if (this.izbranaTelefonska !== null && idUmtsGostovanjeObvescanje === 2) {
        MessageBox.confirm(
          'Ali ste prepričani, da želite spremeniti obveščanje ?', {
            confirmButtonText: 'Da',
            cancelButtonText: 'Prekliči',
            confirmButtonClass: 'gumb-potrdi',
            cancelButtonClass: 'gumb-preklici',
            customClass: 'opozorilo-dialog'
          }).then(() => {
          this.SproziSprememboObvescanja(idUmtsGostovanjeObvescanje)
          this.prenosniPodatkiUmtsObvescanje = 2
        }).catch((err) => {
          err = null
          this.prenosniPodatkiUmtsObvescanje = 1
        })
      }
      if (this.izbranaTelefonska !== null && idUmtsGostovanjeObvescanje === 1) {
        MessageBox.confirm('Ste prepričani, da želite izključiti informativno obveščanje v tujini?', {
          confirmButtonText: 'Da',
          confirmButtonClass: 'gumb-potrdi',
          cancelButtonText: 'Prekliči',
          cancelButtonClass: 'gumb-preklici',
          customClass: 'opozorilo-dialog'
        }).then(() => {
          this.SproziSprememboObvescanja(idUmtsGostovanjeObvescanje)
          this.prenosniPodatkiUmtsObvescanje = 1
        }).catch((err) => {
          err = null
          this.prenosniPodatkiUmtsObvescanje = 2
        })
      }
    },
    SproziSprememboObvescanja (idUmtsGostovanjeObvescanje) {
      let param = ['idPrikljucek=' + this.izbranaTelefonska.id_prikljucek]
      param.push('stevilka=' + this.izbranaTelefonska.telefonska_stevilka)
      param.push('idUmtsGostovanjeObvescanje=' + idUmtsGostovanjeObvescanje)
      this.clientAgent.postWsRequest(this,
        'prikljucek/telefonija/umts/shraniUmtsGostovanjeObvescanje?',
        param,
        null,
        'SetSprememebaInformativnoObvescanjeTujina',
        'ErrSprememebaInformativnoObvescanjeTujina')
    },
    SetSprememebaInformativnoObvescanjeTujina () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno spremenjeno obveščanje v tujini.'
      this.ShowSuccessMessage(paramObvestilo)
      this.GetUmtsGostovanjeObvescanje()
    },
    ErrSprememebaInformativnoObvescanjeTujina (podatki) {
      this.ShowWarningMessage(podatki)
    },
    GetMoznostSMSDeblokade () {
      if (this.izbranaTelefonska !== null && this.izbranaTelefonska !== null) {
        let param = ['idPrikljucek=' + this.izbranaTelefonska.id_prikljucek]
        param.push('stevilka=' + this.izbranaTelefonska.telefonska_stevilka)
        this.clientAgent.postWsRequest(this,
          'prikljucek/telefonija/umts/pridobiMoznostSMSDeblokade?',
          param,
          null,
          'SetMoznostSMSDeblokade',
          'ErrMoznostSMSDeblokade')
      }
    },
    SetMoznostSMSDeblokade (podatki) {
      this.prenosniPodatkiMoznostSMSDeblokade = podatki.data
    },
    ErrMoznostSMSDeblokade (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    NastaviMoznostDeblokadeSMS (statusDeblokadeSms) {
      if (this.izbranaTelefonska !== null) {
        let textGumb = `Da, želim ${statusDeblokadeSms === 'off' ? 'izključiti' : 'vključiti'} deblokado`
        let tekstOpozorilo = `Ste prepričani, da želite ${
          statusDeblokadeSms === 'off'
            ? 'izključiti možnost deblokade podatkovnega prometa preko SMS sporočila?'
            : 'vključiti deblokado podatkovnega prometa prek SMS sporočila?' +
            ' Če je ta možnost omogočena, bo uporabnik lahko nadaljeval s porabo podatkovnega prometa.'
        }`
        MessageBox.confirm(
          tekstOpozorilo,
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: textGumb,
            confirmButtonClass: 'gumb-potrdi',
            cancelButtonText: 'Prekliči',
            cancelButtonClass: 'gumb-preklici',
            customClass: 'opozorilo-dialog'
          }).then(() => {
          this.OmogociDeblokadoSMS(statusDeblokadeSms)
        }).catch((err) => {
          err = null
          this.prenosniPodatkiMoznostSMSDeblokade.status =
            this.prenosniPodatkiMoznostSMSDeblokade.status === 'on' ? 'off' : 'on'
        })
      } else {
        this.OmogociDeblokadoSMS(statusDeblokadeSms)
      }
    },
    OmogociDeblokadoSMS (statusDeblokadeSms) {
      let param = ['idPrikljucek=' + this.izbranaTelefonska.id_prikljucek]
      param.push('stevilka=' + this.izbranaTelefonska.telefonska_stevilka)
      param.push('moznostSmsDeblokade=' + statusDeblokadeSms)
      this.clientAgent.postWsRequest(this,
        'prikljucek/telefonija/umts/nastaviMoznostDeblokadeSMS?',
        param,
        null,
        'SetNastaviMoznostDeblokadeSMS',
        'ErrNastaviMoznostDeblokadeSMS')
    },
    SetNastaviMoznostDeblokadeSMS () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno nastavljena možnost deblokade preko SMS.'
      this.ShowSuccessMessage(paramObvestilo)
    },
    ErrNastaviMoznostDeblokadeSMS (podatki) {
      this.ShowWarningMessage(podatki)
    },
    GetNaborCasovnihIzbir () {
      if (this.izbranaTelefonska !== null) {
        let param = []
        this.clientAgent.postWsRequest(this,
          'prikljucek/telefonija/umts/pridobiNaborCasovnihIzbir?',
          param,
          null,
          'SetNaborCasovnihIzbir',
          'ErrNaborCasovnihIzbir')
      }
    },
    SetNaborCasovnihIzbir (podatki) {
      this.seznamCasovnihIzbir = podatki.data
    },
    ErrNaborCasovnihIzbir (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    GetMednarodnoPodatkovnoBlokado () {
      if (this.jeMobilniTopPaket === false && this.izbranaTelefonska !== null) {
        this.jePridobivanjePodatkovneBlokade = true
        let param = ['idPrikljucek=' + this.izbranaTelefonska.id_prikljucek]
        param.push('stevilka=' + this.izbranaTelefonska.telefonska_stevilka)
        this.clientAgent.postWsRequest(this,
          'prikljucek/telefonija/umts/pridobiMednarodnoPodatkovnoBlokado?',
          param,
          null,
          'SetMednarodnoPodatkovnoBlokado',
          'ErrMednarodnoPodatkovnoBlokado')
      }
    },
    SetMednarodnoPodatkovnoBlokado (podatki) {
      this.mednarodnoPodatkovneBlokade = podatki.data
      for (let i = 0; i < this.mednarodnoPodatkovneBlokade.length; i++) {
        if (this.mednarodnoPodatkovneBlokade[i].status === 'on') {
          this.izbranaMednarodnoPodatkovneBlokade = this.mednarodnoPodatkovneBlokade[i]
        }
      }
      this.jePridobivanjePodatkovneBlokade = false
    },
    ErrMednarodnoPodatkovnoBlokado (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
      this.jePridobivanjePodatkovneBlokade = false
    },
    GetNastaviMednarodnoPodatkovnoBlokado (mednarodnaPodatkovnaBlokada) {
      if (this.jeMobilniTopPaket === false && this.izbranaTelefonska !== null) {
        let param = ['idPrikljucek=' + this.izbranaTelefonska.id_prikljucek]
        param.push('stevilka=' + this.izbranaTelefonska.telefonska_stevilka)
        param.push('mednarodnaPodatkovnaBlokada=' + mednarodnaPodatkovnaBlokada)
        this.clientAgent.postWsRequest(this,
          'prikljucek/telefonija/umts/nastaviMednarodnoPodatkovnoBlokado?',
          param,
          null,
          'SetNastaviMednarodnoPodatkovnoBlokado',
          'ErrNastaviMednarodnoPodatkovnoBlokado')
      }
    },
    SetNastaviMednarodnoPodatkovnoBlokado () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno posodobljena mednarodna podatkovna blokada.'
      this.ShowSuccessMessage(paramObvestilo)
      this.GetMednarodnoPodatkovnoBlokado()
    },
    ErrNastaviMednarodnoPodatkovnoBlokado (podatki) {
      this.ShowWarningMessage(podatki)
    },
    GetNacionalnoPodatkovnoBlokado () {
      if (this.jeMobilniTopPaket === false && this.izbranaTelefonska !== null) {
        this.jePridobivanjePodatkovneBlokade = true
        let param = ['idPrikljucek=' + this.izbranaTelefonska.id_prikljucek]
        param.push('stevilka=' + this.izbranaTelefonska.telefonska_stevilka)
        this.clientAgent.postWsRequest(this,
          'prikljucek/telefonija/umts/pridobiNacionalnoPodatkovnoBlokado?',
          param,
          null,
          'SetNacionalnoPodatkovnoBlokado',
          'ErrNacionalnoPodatkovnoBlokado')
      }
    },
    SetNacionalnoPodatkovnoBlokado (podatki) {
      this.nacionalnePodatkovneBlokade = podatki.data.limits
      for (let i = 0; i < this.nacionalnePodatkovneBlokade.length; i++) {
        if (this.nacionalnePodatkovneBlokade[i].status === 'on') {
          this.izbranaNacionalnaPodatkovnaBlokada = this.nacionalnePodatkovneBlokade[i]
        }
      }
      this.jePridobivanjePodatkovneBlokade = false
    },
    ErrNacionalnoPodatkovnoBlokado (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
      this.jePridobivanjePodatkovneBlokade = false
    },
    GetNastaviNacionalnoPodatkovnoBlokade (izbranaPodatkovnaBlokada) {
      if (this.izbranaTelefonska !== null) {
        let param = ['idPrikljucek=' + this.izbranaTelefonska.id_prikljucek]
        param.push('stevilka=' + this.izbranaTelefonska.telefonska_stevilka)
        param.push('nacionalnaPodatkovnaBlokada=' + izbranaPodatkovnaBlokada)
        this.clientAgent.postWsRequest(this,
          'prikljucek/telefonija/umts/nastaviNacionalnoPodatkovnoBlokado?',
          param,
          null,
          'SetNastaviNacionalnoPodatkovnoBlokade',
          'ErrNastaviNacionalnoPodatkovnoBlokade')
      }
    },
    SetNastaviNacionalnoPodatkovnoBlokade () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno nastavljena izbrana blokada prenosa podatkov.'
      this.ShowSuccessMessage(paramObvestilo)
      this.GetNacionalnoPodatkovnoBlokado()
    },
    ErrNastaviNacionalnoPodatkovnoBlokade (podatki) {
      this.ShowWarningMessage(podatki)
    },
    GetZaporeKlicev () {
      if (this.izbranaTelefonska !== null && this.voiceFeaturesEnabled) {
        this.jePridobivanjeZaporeKlicev = true
        let param = ['idPrikljucek=' + this.izbranaTelefonska.id_prikljucek]
        param.push('stevilka=' + this.izbranaTelefonska.telefonska_stevilka)
        this.clientAgent.postWsRequest(this,
          'prikljucek/telefonija/umts/pridobiZaporeKlicev?',
          param,
          null,
          'SetZaporeKlicev',
          'ErrZaporeKlicev')
      }
    },
    SetZaporeKlicev (podatki) {
      this.zaporeKlicevIzpis = podatki.data
      this.jePridobivanjeZaporeKlicev = false
    },
    ErrZaporeKlicev (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    async NastaviZaporeKlicev (seznamZaporeKlicev) {
      if (this.izbranaTelefonska !== null) {
        let password = ''
        let zapore = []
        for (let i = 0; i < seznamZaporeKlicev.length; i++) {
          if (seznamZaporeKlicev[i].id !== 'password') {
            zapore.push(seznamZaporeKlicev[i])
          } else {
            password = seznamZaporeKlicev[i].value
          }
        }
        let params = {
          idPrikljucek: this.izbranaTelefonska.id_prikljucek,
          stevilka: this.izbranaTelefonska.telefonska_stevilka,
          barrings: JSON.stringify(zapore),
          barringPassword: password
        }
        try {
          await this.clientAgent.makeRequest(
            'prikljucek/telefonija/umts/nastaviZaporeKlicev?',
            params,
            'POST')
          this.SetNastaviZaporeKlicev()
        } catch (e) {
          this.ErrNastaviZaporeKlicev(e)
        }
      }
    },
    SetNastaviZaporeKlicev () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Izbrana zapora klicev uspešno nastavljena.'
      this.ShowSuccessMessage(paramObvestilo)
    },
    ErrNastaviZaporeKlicev (podatki) {
      this.ShowWarningMessage(podatki)
    },
    PridobiPodatkeSim () {
      if (this.izbranaTelefonska !== null && this.izbranaTelefonska !== null) {
        let param = ['idPrikljucek=' + this.izbranaTelefonska.id_prikljucek]
        param.push('stevilka=' + this.izbranaTelefonska.telefonska_stevilka)
        this.clientAgent.postWsRequest(this,
          'prikljucek/telefonija/umts/pridobiPodatkeSim?',
          param,
          null,
          'SetPridobiPodatkeSim',
          'ErrPridobiPodatkeSim')
      }
    },
    SetPridobiPodatkeSim (podatki) {
      this.podatkiOsim = podatki.data
    },
    ErrPridobiPodatkeSim (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    GetKomercialnaSporocila () {
      if (this.izbranaTelefonska !== null && this.izbranaTelefonska !== null && this.voiceFeaturesEnabled) {
        let param = ['idPrikljucek=' + this.izbranaTelefonska.id_prikljucek]
        param.push('stevilka=' + this.izbranaTelefonska.telefonska_stevilka)
        this.clientAgent.postWsRequest(this,
          'prikljucek/telefonija/umts/komercialnaSporocila/info',
          param,
          null,
          'SetKomercialnaSporocila',
          'ErrKomercialnaSporocila')
      }
    },
    SetKomercialnaSporocila (podatki) {
      this.prenosniPodatkiKomercialnaSporocila = {}
      this.prenosniPodatkiKomercialnaSporocila = podatki.data
    },
    BlokadaKomercialnihSporocil () {
      if (this.izbranaTelefonska !== null && this.izbranaTelefonska !== null) {
        let param = ['idPrikljucek=' + this.izbranaTelefonska.id_prikljucek]
        param.push('stevilka=' + this.izbranaTelefonska.telefonska_stevilka)
        this.clientAgent.postWsRequest(this,
          'prikljucek/telefonija/umts/komercialnaSporocila/blokiraj',
          param,
          null,
          'SetBlokadaKomercialnihSporocil',
          'ErrBlokadaKomercialnihSporocil')
      }
    },
    SetBlokadaKomercialnihSporocil () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno nastavljena blokada komercialnih sporočil.'
      this.ShowSuccessMessage(paramObvestilo)
      this.GetKomercialnaSporocila()
    },
    ErrBlokadaKomercialnihSporocil (podatki) {
      this.ShowWarningMessage(podatki)
    },
    DeblokadaKomercialnihSporocil () {
      if (this.izbranaTelefonska !== null && this.izbranaTelefonska !== null) {
        let param = ['idPrikljucek=' + this.izbranaTelefonska.id_prikljucek]
        param.push('stevilka=' + this.izbranaTelefonska.telefonska_stevilka)
        this.clientAgent.postWsRequest(this,
          'prikljucek/telefonija/umts/komercialnaSporocila/deblokiraj',
          param,
          null,
          'SetDeblokadaKomercialnihSporocil',
          'ErrDeblokadaKomercialnihSporocil')
      }
    },
    SetDeblokadaKomercialnihSporocil () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno odpravljena deblokada komercialnih sporočil.'
      this.ShowSuccessMessage(paramObvestilo)
      this.GetKomercialnaSporocila()
    },
    ErrDeblokadaKomercialnihSporocil (podatki) {
      this.ShowWarningMessage(podatki)
    },
    GetRoamingProfile () {
      if (this.izbranaTelefonska !== null) {
        let param = ['idPrikljucek=' + this.izbranaTelefonska.id_prikljucek]
        param.push('stevilka=' + this.izbranaTelefonska.telefonska_stevilka)
        this.clientAgent.postWsRequest(this,
          'prikljucek/telefonija/umts/pridobiRoamingProfile?',
          param,
          null,
          'SetRoamingProfile',
          'ErrRoamingProfile')
      }
    },
    SetRoamingProfile (podatki) {
      this.seznamRoamingProfilov = []
      this.seznamRoamingProfilov = podatki.data
    },
    ErrRoamingProfile (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    SaveRoamingProfile (idProfila) {
      if (this.izbranaTelefonska !== null) {
        let param = ['idPrikljucek=' + this.izbranaTelefonska.id_prikljucek]
        param.push('idProfil=' + idProfila)
        param.push('stevilka=' + this.izbranaTelefonska.telefonska_stevilka)
        this.clientAgent.postWsRequest(this,
          'prikljucek/telefonija/umts/shraniRoamingProfil?',
          param,
          null,
          'SetSaveRoamingProfile',
          'ErrSaveRoamingProfile')
      }
    },
    SetSaveRoamingProfile () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno posodobljeno omrežje.'
      this.ShowSuccessMessage(paramObvestilo)
      this.GetRoamingProfile()
    },
    ErrSaveRoamingProfile (podatki) {
      this.ShowWarningMessage(podatki)
    }
  }
}
</script>
<style scoped src="../../../../../static/css/Nastavitve/Telefonija/NastavitveTelefonija.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/NastavitveTelefonija.vue